import { Dashboard } from "capitalrx-types";

/**
 * Gets the class name for the specified navigation group.
 * @param group The navigation to get the class name for.
 * @returns The class name associated with the navigation group.
 */
export function getNavigationGroupClassName(group: Dashboard.NavigationGroupInfo): string {
  if (typeof group === "string") {
    console.warn(`Group passed in to navigation was a string value (${group}) and not navigation group info, fix ASAP.`);
    return group;
  }

  if (typeof group.id === "undefined") {
    return "hi";
  }

  return group.className ?? group.id.toLowerCase();
}
